// deps
import React, { memo, FormEvent, useState, useEffect } from "react";

// dls
import { RadioGroup } from "@swiggy-private/dls-web-core/dist/components/RadioGroup";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//styles
import { ContentHeader } from "./styles";

// constants
import { TEXTS } from "../constants";

// helpers
import { transformFilterObject } from "../helpers";
import { IFilterContent } from "../types";

function SingleSelectContent({ filter, updateFilterList, selectedFilters }: IFilterContent) {
    const [value, setValue] = useState(selectedFilters[0]);

    useEffect(() => {
        setValue(selectedFilters[0]);
    }, [selectedFilters]);
    return (
        <>
            <ContentHeader>
                <Text variant="V2.body2.neutral.regular" color="text_Med_Emphasis">
                    {filter?.subLabel ?? TEXTS.FILTER_BY}
                </Text>
            </ContentHeader>
            <RadioGroup
                name={filter.label}
                value={value}
                orientation="ltr"
                items={transformFilterObject(filter?.facetInfo)}
                onChange={(e: FormEvent) => {
                    const target = e.target as HTMLInputElement;
                    setValue(target.value);
                    updateFilterList([target.value], filter.id);
                }}
            />
        </>
    );
}

export default memo(SingleSelectContent);
